import { WorkflowsFilterType } from '~/client/graph'

import Localization from '../localization/LocalizationManager'

export type FilterType = WorkflowsFilterType

export const FilterType = {
  ...WorkflowsFilterType,
}

// Ordered list of filter types for workflow filtering UI
export const workflowFilterTypes: FilterType[] = [
  FilterType.Category,
  FilterType.Type,
  FilterType.Status,
  FilterType.Location,
  FilterType.Equipment,
  FilterType.Company,
  FilterType.ResponsibleContact,
  FilterType.Attachment,
  FilterType.Project,
]

// Get localized caption for a filter type
export const getFilterTypeCaption = (type: FilterType): string => {
  switch (type) {
    case FilterType.Status:
      return Localization.translator.workflowStatus
    case FilterType.Location:
      return Localization.translator.location
    case FilterType.Equipment:
      return Localization.translator.equipment
    case FilterType.Company:
      return Localization.translator.company
    case FilterType.Type:
      return Localization.translator.workflowType
    case FilterType.ResponsibleContact:
      return Localization.translator.responsibleContact
    case FilterType.Category:
      return Localization.translator.workflowCategory
    case FilterType.Project:
      return Localization.translator.project
    case FilterType.Attachment:
      return Localization.translator.fileType
    default:
      const _exhaustiveCheck: never = type
      throw new Error(`Unhandled filter type: ${_exhaustiveCheck}`)
  }
}
